// External libraries
import React from 'react';
// @ts-expect-error untyped-import
import { ErrorIcon } from '@checkout/react-components';

// Internal modules
import {
  ErrorContainer,
  ErrorMessage,
  InlineFieldsContainer,
  RadioButtonsContainer,
} from './StyledComponents';
import {
  CreditCardAndBankIconsBar,
  DebitCardIconsBar,
  useSupportedFundingSourcesQuery,
  // @ts-expect-error untyped-import
} from '../CardIconsBar';
import { getContent } from '@/lib';
import { useStoreState } from '@/store';
import { RadioButton } from '@/components/Common';
// @ts-expect-error untyped-import
import { changeHandler } from '@/components/Form/handlers';
import { logBlurOrFocusEvent } from '@/components/Form/utils';

const CARD_PRODUCT_CLASS = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
};

const CardIconsBar = () => {
  const { value } = useStoreState(state => state.form.cardProductClass);

  if (value === CARD_PRODUCT_CLASS.DEBIT) {
    return <DebitCardIconsBar />;
  }

  if (value === CARD_PRODUCT_CLASS.CREDIT) {
    return <CreditCardAndBankIconsBar />;
  }

  return null;
};

const CardProductClassRadioButtons = (): JSX.Element => {
  // prefetching the debit card for better experience
  useSupportedFundingSourcesQuery();
  const { value, displayError, error } = useStoreState(
    state => state.form.cardProductClass,
  );

  const hasError = Boolean(displayError && error);

  return (
    <>
      <RadioButtonsContainer data-testid="card-product-class-radio-buttons">
        <InlineFieldsContainer>
          <RadioButton
            hasError={hasError}
            blurHandler={logBlurOrFocusEvent}
            changeHandler={changeHandler}
            checked={value === CARD_PRODUCT_CLASS.DEBIT}
            id="debit"
            label={getContent('fieldLabels.cardProductClass.DEBIT')}
            name="cardProductClass"
            value={CARD_PRODUCT_CLASS.DEBIT}
          />
          <RadioButton
            hasError={hasError}
            blurHandler={logBlurOrFocusEvent}
            changeHandler={changeHandler}
            checked={value === CARD_PRODUCT_CLASS.CREDIT}
            id="credit"
            label={getContent('fieldLabels.cardProductClass.CREDIT')}
            name="cardProductClass"
            value={CARD_PRODUCT_CLASS.CREDIT}
          />
        </InlineFieldsContainer>
        {hasError && (
          <ErrorContainer>
            <ErrorIcon />
            <ErrorMessage id="cardProductClass-error">
              {getContent('fieldErrors.cardProductClass.valueMissing')}
            </ErrorMessage>
          </ErrorContainer>
        )}
      </RadioButtonsContainer>
      <CardIconsBar />
    </>
  );
};

export { CardProductClassRadioButtons };
